var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DIV",
    [
      _vm.option.name
        ? _c("span", [_vm._v(_vm._s(_vm.option.name))])
        : _vm._e(),
      _vm._v(" "),
      _vm.option.invoice_notes
        ? _c("span", [_vm._v(_vm._s(_vm.option.invoice_notes))])
        : _vm._e(),
      _vm._v(" "),
      _vm.option.contract
        ? _c(
            "DIV",
            { staticClass: "mt-1" },
            [
              _c("UcContractMiniCard", {
                attrs: { item: _vm.option.contract, "no-link": "" }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }